export default __webpack_public_path__ + "static/media/trapstar.9f25849e.jpg";